import { Box } from "@mui/material";
import appStoreBadge from "../assets/images/store-badges/app-store.svg";
import googlePlayBadge from "../assets/images/store-badges/google-play.png";
import { STORE_URLS } from "../constants/externalLinks";

/**
 * Official store artwork, unmodified. Google's PNG carries transparent padding,
 * so it renders taller to match Apple's 40px badge.
 */
const BADGES = {
  appStore: { src: appStoreBadge, height: 40 },
  googlePlay: { src: googlePlayBadge, height: 58 },
};

/** A store badge linking to the Echo listing in a new tab. */
const StoreBadge = ({ store, alt }) => {
  const badge = BADGES[store];
  // A store with no artwork renders nothing rather than throwing. Both callers
  // sit under no error boundary, so the alternative to a missing badge is a
  // blank dashboard or a blank last screen of signup.
  if (!badge) {
    console.error("StoreBadge: missing badge for store");
    return null;
  }

  const { src, height } = badge;

  return (
    <Box
      component="a"
      href={STORE_URLS[store]}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ display: "inline-flex", lineHeight: 0 }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        sx={{ display: "block", height, width: "auto" }}
      />
    </Box>
  );
};

export default StoreBadge;
